import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8de2e5b95142159/components/sections/CtaSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8de2e5b95142159/components/sections/FeaturesCarousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8de2e5b95142159/components/sections/IntegrationsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["KioskFAQ"] */ "/tmp/8de2e5b95142159/components/sections/KioskFAQ.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["KioskFeatures"] */ "/tmp/8de2e5b95142159/components/sections/KioskFeatures.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["QRCaseStudy"] */ "/tmp/8de2e5b95142159/components/sections/QRCaseStudy.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WebshopShowcase"] */ "/tmp/8de2e5b95142159/components/sections/WebshopShowcase.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de2e5b95142159/components/ui/Section.module.css");
